export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ko": {
        "MAIN_MSG_NOPERM": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["열람 권한이 없습니다."])}
      },
      "en": {
        "MAIN_MSG_NOPERM": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You do not have permission to view."])}
      }
    }
  })
}
